export * from './baMenu.service';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/services/baMenu/index.ts